// import ReactHtmlParser from 'react-html-parser';
import { get, getFile } from './apiUtil';
const hljs = require('highlight.js'); // https://highlightjs.org/
const md = require('markdown-it')({
    html: true,
    linkify: true,
    typographer: true,
    highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
            try {
                return hljs.highlight(str, { language: lang }).value;
            } catch (__) { }
        }

        return ''; // use external default escaping
    }
});

function loadDirFromApi(api) {
    const data = new Promise((resolve, reject) => {
        get(api).then(data => {
            return resolve(data);
        })
    })
    return data;
}

function loadFile(api) {
    const data = new Promise((resolve, reject) => {
        getFile(api).then(data => {
            return resolve(data);
        });
    })
    return data;
}

function renderMDFile(data) {
    return <div dangerouslySetInnerHTML={{ __html: md.render(data) }} />;
}

export {
    loadDirFromApi,
    loadFile,
    renderMDFile
}